import BaseModel from '@/orm/models/BaseModel';

export default class Account extends BaseModel {
  static entity = 'accounts';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      plan: this.attr(null),
      nextPlan: this.attr(null),
      period: this.attr(null),
      driver: this.attr(null),
      nextPeriod: this.attr(null),
      quota: this.attr(null),
      periodEnd: this.attr(null),
      periodStart: this.attr(null),
      startDate: this.attr(null),
      active: this.boolean(false),
      next: this.attr(null),
      planPrice: this.attr(null),
      subscriptionEnabled: this.boolean(null),
      expirationDate: this.attr(null),
      hasActivePaymentMethod: this.boolean(false),
      hasFailedRenewal: this.boolean(false),
      quotaBurnDate: this.attr(null),
      multiuserMode: this.attr(null),
      careerPortal: this.attr(null),
      trialAvailable: this.attr(null),
      trialEnabled: this.attr(null),
      aiReview: this.boolean(false),
      transcription: this.boolean(false),
      maximumAiQuestions: this.attr(null),
      maximumVacancies: this.attr(null),
      trialMaximumVacancies: this.attr(null),
      mailTemplate: this.boolean(false),
      hhAiProcessor: this.boolean(false),
    };
  }

  static current() {
    return this.query().withAllRecursive().first();
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get('accounting/current');
      },
      downgradePlan({ planId, periodId, paymentMethodId }) {
        return this.post('accounting/plan/downgrade', {
          planId,
          periodId,
          paymentMethodId,
        });
      },
      changePeriod(periodId) {
        return this.put('accounting/period/change', {
          periodId,
        });
      },
      cancelSubscription() {
        return this.post('accounting/cancel_subscription', null);
      },
      cancelNextPlan(cancelPlan, cancelPeriod) {
        return this.post('accounting/cancel_next_plan', {
          cancelPlan,
          cancelPeriod,
        });
      },
      renewActiveSubscription() {
        return this.post('/accounting/renew_subscription', null);
      },
      renewSubscriptionOnDefaultPlan() {
        return this.post('/accounting/renew_subscription_on_default_plan', null);
      },
      startTrial(payload) {
        return this.post('/billing/trial/start', payload, { save: false });
      },
    },
  }
}
